import { useState } from "react";
import { useAuth } from "../../../context/contextAuth";
import { getIpResults } from "../../../api/get/azure/get-ip";
import { scanVmsIp } from "../../../api/post/post-azure";

const useAzureIp = () => {
  const { userId, user } = useAuth();

  // MAIN STATES
  const [networkLoading, setNetworkLoading] = useState(false);
  const [ip, setIp] = useState("");
  const [error, setError] = useState({
    message: null,
    card: false
  });

  // RESULTS FROM BACKEND
  const [networkResults, setNetworkResults] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // TABLES FOR UI
  const [ipVulTable, setIpVulTable] = useState([]);
  const [ipEpssTable, setIpEpssTable] = useState([]);
  const [ipServices, setIpServices] = useState([]);

  // SCORE DATA
  const [TVulScore, setTVulScore] = useState(0);
  const [CVulScore, setCVulScore] = useState(0);
  const [saveScore, setSaveScore] = useState(0);

  // DASHBOARD CONTROL FLAGS
  const [ipScanLoading, setIpScanLoading] = useState(false);
  const [ipDashboardView, setIpDashboardView] = useState(false);
  const [ipHeader, setIpHeader] = useState(false);

  const initData = async () => {
    if (!user) {
      resetState();
      return;
    }

    await fetchNetworkResults(userId);
    if(!networkLoading) await loadNetworkData(0);
  };

  const fetchNetworkResults = async (userId) => {
    try {
      const results = await getIpResults(userId);
      setNetworkResults(results);
      return results;
    } catch (error) {
      console.error("Error fetching network results:", error);
      setNetworkResults([]);
      return [];
    }
  };

  const loadNetworkData = async (index) => {
    const scan = networkResults[index];
    if (!scan) return;

    setCurrentIndex(index);
    setIpVulTable(scan.vuln_data || []);
    setIpEpssTable(scan.epss_data || []);
    setIpServices(scan.services || []);
    setTVulScore(scan.t_vul);
    setCVulScore(scan.c_vul);
    setSaveScore(scan.ss);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIpDashboardView(true);
    setIpScanLoading(true);
    setIpHeader(false);

    try {
      await scanVmsIp(userId, ip);
      const results = await fetchNetworkResults(userId);
      await loadNetworkData(results.length - 1);
    } catch (error) {
      console.log(error.message);
      setIpDashboardView(false);
      setError(error.message);
    } finally {
      setIpScanLoading(false);
      setIpHeader(true);
      setIp("");
      setTimeout(() => setError(null), 6000);
    }
  };

  const resetState = () => {
    setNetworkLoading(false);
    setIp("");
    setError(null);

    setNetworkResults([]);
    setCurrentIndex(0);

    setIpVulTable([]);
    setIpEpssTable([]);
    setIpServices([]);

    setTVulScore(0);
    setCVulScore(0);
    setSaveScore(0);

    setIpScanLoading(false);
    setIpDashboardView(false);
    setIpHeader(false);
  };

  return {
    networkLoading,
    ip,
    error,

    networkResults,
    currentIndex,

    ipVulTable,
    ipEpssTable,
    ipServices,

    TVulScore,
    CVulScore,
    saveScore,

    ipScanLoading,
    ipDashboardView,
    ipHeader,

    // SETTERS
    setIp,
    setCurrentIndex,
    setIpDashboardView,
    setIpHeader,

    // FUNCTIONS
    initData,
    loadNetworkData,
    handleSubmit,
    resetState,
  };
};

export default useAzureIp;
